import React from 'react';
import { SubsectionWrapper, SubsectionTitle } from '../Guide.styles';

interface GuideSubsectionProps {
  id: string;
  title: string;
  children: React.ReactNode;
}

export const GuideSubsection: React.FC<GuideSubsectionProps> = ({ id, title, children }) => (
  <SubsectionWrapper id={id}>
    <SubsectionTitle variant="h6">{title}</SubsectionTitle>
    {children}
  </SubsectionWrapper>
);
